<div
*ngIf="data$ | async as data; else loadingTemplate"
class="position-relative"
>
<div class="row action-row">
  <div class="col p-0 pr-2">
    <div class="text-muted employee-name">
      <a [routerLink]="['/employee', data.employee.employee_ID, 'detail', 'overview']" class="anchor-unstyled underline-on-hover"> <span>{{ data.employee.fullname }} </span></a>
      <span>{{ year }}</span>
      <span>/</span>
      <span>{{ month }}</span>
    </div>
  </div>
  <div *ngIf="data.prev_next" class="col-sm-auto col-12 prev-next-employee">
        <span *ngIf="data.prev_next?.prev as prev">
          <i class="mdi mdi-chevron-left"></i>
          <span (click)="navigateToEntity(prev.employee_ID)">{{ prev.fullname }}</span>
        </span>
    <span *ngIf="data.prev_next?.prev && data.prev_next?.next" class="mr-3 space"></span>
    <span *ngIf="data.prev_next?.next as next">
          <span (click)="navigateToEntity(next.employee_ID)">{{ next.fullname }}</span>
          <i class="mdi mdi-chevron-right"></i>
        </span>
  </div>
</div>

<div class="row">
  <div class="mt-4 mt-sm-0 col-12 d-block d-xl-none text-right">
    <ng-container [ngTemplateOutlet]="buttonsCard"></ng-container>
  </div>

  <div class="col-xl-9 mb-3">
    <div class="card h-100 shadow">
      <app-help name="attendance.documents.detail.employee.info_table"></app-help>
      <form #tableUpdateForm="ngForm">
        <div class="card-body p-2">
          <div class="table-responsive table-compact-p-5px">
            <app-data-table
                [customNoDataMessage]="'global.empty_widget_error' | translate"
                [disableInPlaceSorting]="true"
                [rows]="data.dates"
                [showSearch]="false"
            >
              <ng-template #headerRow>
                <th [disableSort]="true" appDataTableHeaderCell>{{ 'employees_datetimes.day' | translate }}</th>
                <th *ngIf="(availableFeatures$ | async).shifts" [disableSort]="true" appDataTableHeaderCell style="max-width: 100px">{{ 'employees_datetimes.attendance_type_shift' | translate }}</th>
                <th [disableSort]="true" appDataTableHeaderCell>{{ 'employees_datetimes.work_start' | translate }}</th>
                <th [disableSort]="true" appDataTableHeaderCell>{{ 'employees_datetimes.work_end' | translate }}</th>
                <th [disableSort]="true" appDataTableHeaderCell>{{ 'employees_datetimes.detail' | translate }}</th>
                <th [disableSort]="true" appDataTableHeaderCell>{{ 'employees_datetimes.Total' | translate }}</th>
                <th *ngIf="data.employees_datetimes_projects" [disableSort]="true" appDataTableHeaderCell>{{ 'employees_datetimes.project' | translate }}</th>
                <th [disableSort]="true" appDataTableHeaderCell>{{ 'employees_datetimes.absence_start' | translate }}</th>
                <th [disableSort]="true" appDataTableHeaderCell>{{ 'employees_datetimes.absence_end' | translate }}</th>
                <th [disableSort]="true" appDataTableHeaderCell>{{ 'employees_datetimes.detail' | translate }}</th>
                <th [disableSort]="true" appDataTableHeaderCell>{{ 'employees_datetimes.Total' | translate }}</th>
                <th *ngIf="!data.is_uneven" [disableSort]="true" appDataTableHeaderCell>{{ 'employees_datetimes.saldo' | translate }}</th>
                <th *ngIf="data.meal_vouchers" [disableSort]="true" appDataTableHeaderCell>{{ 'employees_datetimes.meal_vouchers' | translate }}</th>
                <th *ngIf="data.meal_allowance" [disableSort]="true" appDataTableHeaderCell>{{ 'employees_datetimes.meal_allowance' | translate }}</th>
                <th [disableSort]="true" appDataTableHeaderCell>{{ 'employees_datetimes.table_action' | translate }}</th>
              </ng-template>

              <ng-template #dataRow
                           let-index="index"
                           let-row
              >
                <ng-container [ngModelGroup]="index">
                  <td [ngClass]="{'bg-light': row.is_holiday || row.is_weekend}" appDataTableDataCell>
                    {{ row.date | date: 'dd.MM.yyyy' }}
                  </td>

                  <td *ngIf="(availableFeatures$ | async).shifts" [ngClass]="{'bg-light': row.is_holiday || row.is_weekend}" appDataTableDataCell style="max-width: 100px">
                <span *ngFor="let shiftType of row.shift_datetime_types; let isLast = last">
                  <span *ngIf="shiftType.abbreviation" [ngStyle]="{'color': shiftType.color}">{{ shiftType.abbreviation }}</span>
                  <span *ngIf="!isLast">, </span>
                </span>
                  </td>


                  <td [ngClass]="{'bg-light': row.is_holiday || row.is_weekend}" appDataTableDataCell>
                    <div *ngFor="let from of row.work.from | keyvalue; let i = index"
                         [ngbTooltip]="row.work?.multiple_days?.[i] === true ? ('employees_datetimes.multiple_attendance_day_description' | translate) : null">
                      <input (flatpickrChange)="onFromToChange($event, index, from.value, 'from', i)" (flatpickrClose)="fpHelper.applyAltInputValue($event, false)" *ngIf="from.value" [allowInput]="true"
                             [altInput]="true"
                             [disableMobile]="true"
                             [disabled]="row.work?.multiple_days?.[i] === true"
                             [enableTime]="true"
                             [locale]="locale$ | async"
                             [ngModel]="from.value"
                             [noCalendar]="true"
                             [time24hr]="true"
                             altFormat="H:i"
                             class="form-control-table"
                             dateFormat="H:i"
                             mwlFlatpickr
                             name="from{{i}}"
                             type="text"
                      >
                    </div>
                  </td>

                  <td [ngClass]="{'bg-light': row.is_holiday || row.is_weekend}" appDataTableDataCell>
                    <div *ngFor="let to of row.work.to | keyvalue; let i = index"
                         [ngbTooltip]="row.work?.multiple_days?.[i] === true ? ('employees_datetimes.multiple_attendance_day_description' | translate) : null">
                      <input (flatpickrChange)="onFromToChange($event, index, to.value, 'to', i)" (flatpickrClose)="fpHelper.applyAltInputValue($event, false)" *ngIf="to.value" [allowInput]="true"
                             [altInput]="true"
                             [disableMobile]="true"
                             [disabled]="row.work?.multiple_days?.[i] === true"
                             [enableTime]="true"
                             [locale]="locale$ | async"
                             [ngModel]="to.value"
                             [noCalendar]="true"
                             [time24hr]="true"
                             altFormat="H:i"
                             class="form-control-table"
                             dateFormat="H:i"
                             mwlFlatpickr
                             name="to{{i}}"
                             type="text"
                      >
                    </div>
                  </td>

                  <td [ngClass]="{'bg-light': row.is_holiday || row.is_weekend}" appDataTableDataCell class="text-left">
                    <ng-container *ngFor="let datetimeId of row.work.datetime_ids | keyvalue; let i = index">
                      <div *ngIf="datetimeId.value">
                        <span (click)="openDatetimeModal(datetimeId.value)"
                              class="cursor-pointer mr-1"
                              title="{{ 'employees.action_view' | translate }}"
                        >
                          <i class="mdi mdi-eye-outline mdi-18px text-muted" style="line-height: 18px"></i>
                        </span>
                        <span (click)="onSubmitRow(index, tableUpdateForm, datetimeId.value, row.date, 'attendance', i)"
                              [ngStyle]="{'visibility': (datetimeId.value && (rowChanged[index]?.['from' + i.toString()] || rowChanged[index]?.['to' + i.toString()]) ? 'visible' : 'hidden')}"
                              class="cursor-pointer"
                              title="{{ 'employees.action_save' | translate }}"
                        >
                        <i class="mdi mdi-check mdi-18px text-muted" style="line-height: 18px"></i>
                      </span>
                      </div>
                    </ng-container>
                  </td>

                  <td [ngClass]="{'bg-light': row.is_holiday || row.is_weekend}" appDataTableDataCell>
                    {{ row.work.total }}
                  </td>

                  <td *ngIf="data.employees_datetimes_projects" [ngClass]="{'bg-light': row.is_holiday || row.is_weekend}" appDataTableDataCell>
                    {{ row.work.datetime_project_names.join(', ') }}
                  </td>

                  <td [ngClass]="{'bg-light': row.is_holiday || row.is_weekend}" appDataTableDataCell>
                    <div *ngFor="let from of row.absence.from | keyvalue; let i = index"
                         [ngbTooltip]="row.absence?.multiple_days?.[i] === true ? ('employees_datetimes.multiple_attendance_day_description' | translate) : null">
                      <input (flatpickrChange)="onFromToChange($event, index, from.value, 'from_absence', i)" (flatpickrClose)="fpHelper.applyAltInputValue($event, false)" *ngIf="from.value" [allowInput]="true"
                             [altInput]="true"
                             [disableMobile]="true"
                             [disabled]="row.absence?.multiple_days?.[i] === true"
                             [enableTime]="true"
                             [locale]="locale$ | async"
                             [ngModel]="from.value"
                             [noCalendar]="true"
                             [time24hr]="true"
                             altFormat="H:i"
                             class="form-control-table"
                             dateFormat="H:i"
                             mwlFlatpickr
                             name="from_absence{{i}}"
                             type="text"
                      >
                    </div>
                  </td>

                  <td [ngClass]="{'bg-light': row.is_holiday || row.is_weekend}" appDataTableDataCell>
                    <div *ngFor="let to of row.absence.to | keyvalue; let i = index"
                         [ngbTooltip]="row.absence?.multiple_days?.[i] === true ? ('employees_datetimes.multiple_attendance_day_description' | translate) : null">
                      <input (flatpickrChange)="onFromToChange($event, index, to.value, 'to_absence', i)" (flatpickrClose)="fpHelper.applyAltInputValue($event, false)" *ngIf="to.value" [allowInput]="true"
                             [altInput]="true"
                             [disableMobile]="true"
                             [disabled]="row.absence?.multiple_days?.[i] === true"
                             [enableTime]="true"
                             [locale]="locale$ | async"
                             [ngModel]="to.value"
                             [noCalendar]="true"
                             [time24hr]="true"
                             altFormat="H:i"
                             class="form-control-table"
                             dateFormat="H:i"
                             mwlFlatpickr
                             name="to_absence{{i}}"
                             type="text"
                      >
                    </div>
                  </td>

                  <td [ngClass]="{'bg-light': row.is_holiday || row.is_weekend}" appDataTableDataCell>
                    <ng-container *ngFor="let datetimeId of row.absence.datetime_ids | keyvalue; let i = index">
                      <div *ngIf="datetimeId.value">
                        <span (click)="openDatetimeModal(datetimeId.value)"
                              class="cursor-pointer mr-1"
                              title="{{ 'employees.action_view' | translate }}"
                        >
                          <i class="mdi mdi-eye-outline mdi-18px text-muted" style="line-height: 18px"></i>
                        </span>
                        <span (click)="onSubmitRow(index, tableUpdateForm, datetimeId.value, row.date, 'absence', i)"
                              [ngStyle]="{'visibility': (datetimeId.value && (rowChanged[index]?.['from_absence' + i.toString()] || rowChanged[index]?.['to_absence'+ i.toString()]) ? 'visible' : 'hidden')}"
                              class="cursor-pointer"
                              title="{{ 'employees.action_save' | translate }}"
                        >
                        <i class="mdi mdi-check mdi-18px text-muted" style="line-height: 18px"></i>
                      </span>
                      </div>
                    </ng-container>
                  </td>

                  <td [ngClass]="{'bg-light': row.is_holiday || row.is_weekend}" appDataTableDataCell>
                    {{ row.absence.total }}
                  </td>

                  <td *ngIf="!data.is_uneven" [ngClass]="{'bg-light': row.is_holiday || row.is_weekend}" appDataTableDataCell>
                    {{ row.saldo }}
                  </td>

                  <td *ngIf="data.meal_vouchers" [ngClass]="{'bg-light': row.is_holiday || row.is_weekend, 'text-danger': !row.meal_vouchers, 'text-green': row.meal_vouchers}" appDataTableDataCell>
                    {{ 'global.' + (row.meal_vouchers ? 'YES' : 'NO') | translate }}
                  </td>

                  <td *ngIf="data.meal_allowance" [ngClass]="{'bg-light': row.is_holiday || row.is_weekend, 'text-danger': !row.meal_allowance, 'text-green': row.meal_allowance}" appDataTableDataCell>
                    {{ 'global.' + (row.meal_allowance ? 'YES' : 'NO') | translate }}
                  </td>

                  <td [ngClass]="{'bg-light': row.is_holiday || row.is_weekend}" appDataTableDataCell>
                    <span (click)="openDatetimeModal(null, row.date)"
                          class="cursor-pointer"
                          title="{{ 'employees.action_create' | translate }}"
                    >
                        <i class="mdi mdi-plus mdi-18px text-muted" style="line-height: 18px"></i>
                      </span>
                  </td>
                </ng-container>
              </ng-template>
            </app-data-table>
          </div> <!-- end table-responsive-->
        </div>
      </form>
    </div>
  </div>

  <div class="col-xl-3">
    <div class="row">
      <div class="col-12 d-none d-xl-block">
        <ng-container [ngTemplateOutlet]="buttonsCard"></ng-container>
      </div>
      <div class="col-12 mb-3">
        <div class="card h-100 shadow">
          <app-help name="attendance.documents.detail.employee.info_summary"></app-help>
          <div class="card-header card-header--padding">
            <div class="row">
              <div class="col-12">
                <p class="modal-title font-16 text-dark pt-2 pb-2">
                  <span>{{ 'employees_datetimes.summary' | translate }} </span>
                </p>
              </div>
            </div>
          </div>

          <div class="card-body p-2">
            <div class="table-responsive">
              <table class="table table-centered mb-0">
                <tbody>
                  <tr>
                    <td><strong>{{ 'employees_datetimes.whole_month' | translate }} </strong></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>{{ 'employees_datetimes.expected' | translate }}</td>
                    <td class="text-right">{{ data.summary.whole_month.expected }}</td>
                  </tr>
                  <tr>
                    <td>{{ 'employees_datetimes.expected_with_holidays' | translate }}</td>
                    <td class="text-right">{{ data.summary.whole_month.expected_with_holidays }}</td>
                  </tr>
                  <tr>
                    <td>{{ 'employees_datetimes.real' | translate }}</td>
                    <td class="text-right">{{ data.summary.whole_month.real }}</td>
                  </tr>
                  <tr>
                    <td>{{ 'employees_datetimes.saldo' | translate }}</td>
                    <td class="text-right">{{ data.summary.whole_month.saldo }}</td>
                  </tr>
                  <tr>
                    <td>{{ 'employees_datetimes.holidays_work' | translate }}</td>
                    <td class="text-right">{{ data.summary.whole_month.holidays_work }}</td>
                  </tr>
                  <tr>
                    <td>{{ 'employees_datetimes.weekends_work' | translate }}</td>
                    <td class="text-right">{{ data.summary.whole_month.weekends_work }}</td>
                  </tr>
                    <tr>
                        <td>{{ 'employees_datetimes.nights_work' | translate }}</td>
                        <td class="text-right">{{ data.summary.whole_month.night_work }}</td>
                    </tr>
                  <tr *ngIf="data.summary.whole_month.meal_vouchers">
                    <td>{{ 'employees_datetimes.meal_vouchers' | translate }}</td>
                    <td class="text-right">{{ data.summary.whole_month.meal_vouchers }}</td>
                  </tr>
                  <tr *ngIf="data.summary.whole_month.meal_allowance">
                    <td>{{ 'employees_datetimes.meal_allowance' | translate }}</td>
                    <td class="text-right">{{ data.summary.whole_month.meal_allowance }}</td>
                  </tr>
                </tbody>
                <tbody *ngIf="data.summary.whole_month.worktime_summaries">
                  <tr>
                    <td><strong>{{ 'employees_datetimes.worktime_summaries' | translate }} </strong></td>
                    <td></td>
                  </tr>
                  <tr *ngFor="let worktime of data.summary.whole_month.worktime_summaries">
                    <td>{{ worktime.key }}</td>
                    <td class="text-right">{{ worktime.value }}</td>
                  </tr>
                </tbody>
                <tbody *ngIf="data.summary.whole_month.absence_summaries.length">
                  <tr>
                    <td><strong>{{ 'employees_datetimes.absence_summaries' | translate }} </strong></td>
                    <td></td>
                  </tr>
                  <tr *ngFor="let absence of data.summary.whole_month.absence_summaries">
                    <td>{{ absence.key }}</td>
                    <td class="text-right">{{ absence.value }}</td>
                  </tr>
                </tbody>
                <tbody *ngIf="data.summary.whole_month.neutral_summaries.length">
                  <tr>
                    <td><strong>{{ 'employees_datetimes.neutral_summaries' | translate }} </strong></td>
                    <td></td>
                  </tr>
                  <tr *ngFor="let absence of data.summary.whole_month.neutral_summaries">
                    <td>{{ absence.key }}</td>
                    <td class="text-right">{{ absence.value }}</td>
                  </tr>
                </tbody>
                <tbody *ngIf="data.employees_datetimes_projects">
                  <tr>
                    <td><strong>{{ 'employees_datetimes.projects.label' | translate }} </strong></td>
                    <td></td>
                  </tr>
                  <tr *ngFor="let project of data.summary.project_summaries">
                    <td>{{ project.name }}</td>
                    <td class="text-right">{{ project.total }}</td>
                  </tr>
                </tbody>
              </table>
            </div> <!-- end table-responsive-->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #buttonsCard>
  <div class="card">
    <div class="card-body p-2">
      <button (click)="goToMonthOverview(prevYear, prevMonth)"
              class="btn btn-primary m-1"
              style="min-width: 0 !important; padding-left: 12px !important; padding-right: 12px !important;">< {{ prevYear + '/' + prevMonth }}
      </button>
      <button (click)="goToMonthOverview(nextYear, nextMonth)"
              [disabled]="!nextActive"
              class="btn btn-primary m-1"
              style="min-width: 0 !important; padding-left: 12px !important; padding-right: 12px !important;">{{ nextYear + '/' + nextMonth }} >
      </button>
      <app-protect-unprotect-datetimes (stateChanged)="init()" [employees]="employeeID" [from]="from" [state]="data.summary.protection_state.protected_ratio === 0" [to]="to" class="m-1"></app-protect-unprotect-datetimes>
      <app-toggle-attendance-approvement (stateChanged)="init()" [date]="from" [employees]="employeeID" [state]="data.attendance_locked" class="m-1"></app-toggle-attendance-approvement>
      <a
          (click)="recalculateDatetimes()"
          class="btn btn-light btn-icon m-1"
          title="{{ 'employees_datetimes.recalculate_attendance' | translate }}"
      >
        <i class="mdi mdi-timer-refresh-outline mdi-24px text-muted"></i>
      </a>
      <button (click)="downloadAsPDF(year, month, data)" class="btn btn-primary btn-icon m-1"><span class="mdi mdi-file-pdf-box"></span></button>
    </div>
  </div>
</ng-template>
</div>


<ng-template #loadingTemplate>
  <div class="row">
    <div class="col-12 col-lg-8">
      <div class="card shadow p-3">
        <div class="item">
          <ngx-skeleton-loader [theme]="{
                        'margin': '13px 0'
                      }" appearance="line" count="10"></ngx-skeleton-loader>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="card shadow p-3">
        <div class="item">
          <ngx-skeleton-loader [theme]="{
                        'margin': '13px 0'
                      }" appearance="line" count="10"></ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
</ng-template>
